<template>
  <div>
    <h3 class="title is-3">Maps</h3>

    <button @click="openMapImporter" class="button is-primary btn-margin">Import KML map</button>

    <b-tooltip label="Import your own Google Maps in KML format" type='is-warning'>
      <b-icon icon="help-circle" type="grey-light"></b-icon>
    </b-tooltip>
    <div><p>&nbsp;</p></div>

    <b-modal :active.sync="showPhotoDialog"
             :destroy-on-hide="true"
             scroll="keep"
             trap-focus>
      <div style="background-color: white;" align="center">
        <h1 class="dialogTitle">Change the photo of the map<br /><b>{{selectedMapName}}</b></h1>
        <picture-input
                style="width: 250px; margin-top: 5px;padding: 20px"
                id="pictureInput"
                ref="logo"
                @change="onPictureSelected"
                width="250"
                height="150"
                buttonClass="button is-primary is-outlined"
                removeButtonClass="button is-outlined"
                :customStrings="fileUploadCustomTexts"
                :removable="false"
        />
        <button v-if="logoCompressedUrl" @click="updateImage" btn-margin class="button is-info" style="margin: 20px">Save
        </button>
    </div>
    </b-modal>
    <b-table
        :data="maps"
        :loading="isLoading"
        :default-sort="['name', 'asc']"
        :striped="true"
        :paginated="true"
        :per-page="50"
        :pagination-simple="true"
        :hoverable="true">
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="name" label="Map name" sortable searchable>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="description" label="Description" sortable>
          {{ props.row.description }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="geoLocationsCount" label="Locations count" sortable>
          {{ props.row.geoLocationsCount }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="imageUrl" label="Image">
          <img v-if="props.row.imageUrl" :src="props.row.imageUrl" width="65" />
        </b-table-column>

        <b-table-column class="centered-table-content" label="Actions">
          <button class="button btn-margin" @click="previewMap(props.row.mapId)">Preview
          </button>
          <button class="button is-info is-outlined"
                  @click="showChangeImage(props.row.mapId, props.row.name, props.row.imageUrl)">Change image
          </button>
          <button class="btn-margin button is-danger is-outlined" @click="openMapDeleteDialog(props.row.mapId)">Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import mapService from '../services/mapService'
import displayHelper from '../helpers/display-helper'
import {DialogProgrammatic as Dialog} from 'buefy'
import imageHelper from '../helpers/image-helper'
import PictureInput from 'vue-picture-input'

export default {
  name: 'Maps',
  components: {
    PictureInput,
  },
  data() {
    return {
      isLoading: false,
      maps: [],
      fileUploadCustomTexts: {
        upload: '<h1>Bummer!</h1>',
        drag: 'Drop file here or click here to upload'
      },
      selectedMapId: null,
      selectedMapName: null,
      logoCompressedUrl: null,
      showPhotoDialog: false,
    }
  },
  created() {
    this.isLoading = true
    this.loadMapsList()
  },
  methods: {
    updateImage() {
      if (this.selectedMapId && this.logoCompressedUrl) {
        this.isLoading = true
        mapService
                .updateImage(this.selectedMapId, this.logoCompressedUrl)
                .then(() => {
                  this.selectedMapId = null
                  this.selectedMapName = null
                  this.logoCompressedUrl = null
                  this.showPhotoDialog = false

                  this.isLoading = false
                  this.$router.go()
                })
      }
    },
    showChangeImage(mapId, name) {
      this.showPhotoDialog = true
      this.selectedMapId = mapId
      this.selectedMapName = name
    },
    onPictureSelected(logo) {
      if (logo) {
        imageHelper.compressImg(logo)
                .then((logoCompressedUrl) => {
                  this.logoCompressedUrl = logoCompressedUrl
                })
      }
    },
    loadMapsList() {
      const parent = this
      this.isLoading = true
      mapService.getMaps()
          .then(maps => {
            this.maps = maps
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
    },
    previewMap(id) {
      this.$router.push({name: 'PreviewMap', params: {id: id}})
    },
    openMapDeleteDialog(mapId) {
      Dialog.confirm({
        message: 'Are you sure you want to delete this map?',
        onConfirm: () => this.deleteMap(mapId)
      })
    },
    deleteMap(mapId) {
      const parent = this
      this.isLoading = true
      mapService.deleteMap(mapId)
          .then(() => {
            displayHelper.displaySuccess(parent, 'Map successfully deleted')
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while deleting the map: ' + err.message)
          })
          .finally(() => {
            this.loadMapsList()
          })
    },
    openMapCreator() {
      return ''
    },
    openMapImporter() {
      this.$router.push(`maps/import`)
    },
    generateChallenges(mapId) {
      this.$router.push({name: 'GenerateChallenges', params: {mapId: mapId}})
    }
  }
}
</script>

<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}

.picture-input /deep/ .preview-container {
  margin: 0;
  z-index: 1 !important;
}

.picture-input /deep/ .picture-preview {
  margin: 0;
  z-index: 1 !important;
}

.picture-input /deep/ .picture-inner {
  z-index: 1 !important;
}

.picture-input {
  text-align: left !important;
}

.picture-input /deep/ .preview-container {
  margin: 0;
}

#pictureInput, #injectedPreview {
  height: 150px;
  width: 250px;
  position: absolute;
}

#injectedPreviewImage {
  height: 150px;
  width: 250px;
}

#injectedPreview {
  top: 0;
  z-index: 10;
}

.dialogTitle {
  font-size: 1.5em;
  padding-top: 20px;
  margin: 20px;
}

</style>
